import { Target, Sparkles } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const AboutMission = () => {
  const { t } = useLanguage();
  const p = "aboutMission";

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Target className="w-4 h-4" />
              {t(`${p}.badge`)}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-primary">{t(`${p}.title`)}</h2>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="flex gap-4 mb-6">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center shrink-0">
                <Sparkles className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-foreground mb-4">{t(`${p}.subtitle`)}</h3>
              </div>
            </div>

            <div className="space-y-4 text-lg text-muted-foreground">
              <p>{t(`${p}.p1`)}</p>
              <p>{t(`${p}.p2`)}</p>
              <p className="text-foreground font-medium border-l-4 border-accent pl-4">{t(`${p}.highlight`)}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMission;
